module.exports = __webpack_public_path__ + "static/media/90-landcruiser-2.25586118.jpg";